import WidgetWithInlineLoaderOnCallbackMixin from "../../mixins/WidgetWithInlineLoaderOnCallbbackMixin";

Vue.asyncComponent('ak-popover-menu-item', {
    mixins: [
        WidgetWithInlineLoaderOnCallbackMixin
    ],
    data() {
        return {
            open: false,
            showConfirm: false,
        }
    },
    props: {
        title: {
            type: String,
            required: false,
        },
        href: {
            type: String,
            required: false,
        },
        openInNewTab: {
            type: Boolean|Number,
            required: false,
        },
        active: {
            type: Boolean,
            required: false,
        },
        showArrow: {
            type: Boolean,
            required: false,
            default: false,
        },
        colorMode: {
            type: String,
            required: false,
        },
        icon: {
            type: String,
            required: false,
        },
        image: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
        enableConfirm: {
            type: Boolean,
            required: false,
            default: false
        },
        confirmTitle: {
            type: String,
            required: false,
        },
        confirmText: {
            type: String,
            required: false,
        },
        confirmButtonTitle: {
            type: String,
            required: false
        },
        cancelButtonTitle: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        showDivider: {
            type: Boolean,
            required: false,
        },
    },
    computed: {
        /**
         * Current confirm button title
         * @return {*}
         */
        currentConfirmButtonTitle() {
            return this.confirmButtonTitle || this.$t('Bevestigen');
        },
        /**
         * Current cancel button title
         * @return {*}
         */
        currentCancelButtonTitle() {
            return this.cancelButtonTitle || this.$t('Annuleren');
        }
    },
    methods: {
        click(e) {
            e.preventDefault();

            if (this.enableConfirm) {
                this.showConfirm = true;
                return;
            }

            this.$emit('click', e);

            if (this.href) {
                this.$actionHandler.handleRoute({route:this.href, target:this.openInNewTab ? '_blank' : null});
            }
        },
        onConfirm(e) {
            this.showConfirm = false;
            this.$emit('click', e);
            if (this.href) {
                this.$actionHandler.handleRoute({route:this.href, target:this.openInNewTab ? '_blank' : null});
            }
        },
        onCancel(e) {
            this.showConfirm = false;
        }
    }
}, 'layout/partials/ak-popover-menu-item.html');